import { render, staticRenderFns } from "./PointsHistory.vue?vue&type=template&id=73e093e6"
import script from "./PointsHistory.vue?vue&type=script&lang=js"
export * from "./PointsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports